<template>
  <va-card>
    <template slot="header">
      <div class="va-card__header-title" color="secondary">
        <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / <router-link to="/bolge/listesi">{{ $t('menu.regions') }}</router-link> / {{ form.name_readable }}        
      </div>
      <div class="va-card__header-actions"/>
    </template>
    <form @submit.prevent="onsubmit">
      <div class="row">
        <div class="flex md4 sm6 xs12">
          <va-input
            v-model="form.name"
            label="İsim [EN]"
            placeholder="Bölge ismi çevirisi girin"
          />
        </div>
      </div>
      <div class="row">
        <va-button type="submit">Kaydet</va-button>
      </div>
    </form>
  </va-card>
</template>

<script>
import regionServices from '../../services/api/region'
import responseMixin from '../../services/api/response'
export default {
  mixins: [responseMixin],
  data () {
    return {
      form: {}
    }
  },
  methods: {
    async getRegion(id){
      const result = await regionServices.get(id);
      if(result.error){
        this.item = {};
        return ;
      }
      this.form = result.data.data;
      this.form.language = 'en';
      this.form.name = this.form.name.en ? this.form.name.en : '';
    },
    async putRegion(id) {
      const res = await regionServices.put(id, {
        data: this.form
      });
      if(res.error){
        //error handling
        this.responseToast('PUT', 'error', res);
        return ;
      }
      this.responseToast('PUT', 'success');
    },
    onsubmit () {
      //validation
      this.putRegion(this.$route.params.id);
    },
  },
  created () {
    if(this.$route.params.id) {
      this.getRegion(this.$route.params.id);
    }
  },
}
</script>